// extracted by mini-css-extract-plugin
export var drawerContent = "_3j-0";
export var valueBlock = "_3j-1";
export var valueBlockFrom = "_3j-2 _3j-1";
export var valueBlockTo = "_3j-3 _3j-1";